import { render, staticRenderFns } from "./chemUpdate.vue?vue&type=template&id=c5d94e84"
import script from "./chemUpdate.vue?vue&type=script&lang=js"
export * from "./chemUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5d94e84')) {
      api.createRecord('c5d94e84', component.options)
    } else {
      api.reload('c5d94e84', component.options)
    }
    module.hot.accept("./chemUpdate.vue?vue&type=template&id=c5d94e84", function () {
      api.rerender('c5d94e84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/form/chemUpdate.vue"
export default component.exports